// extracted by mini-css-extract-plugin
export var divider = "_yj-0";